import type { FormField } from '@shared/components/add-form/add-form.component';

export const COUPON_ISSUE_FORM_FIELDS: FormField[] = [
  {
    label: 'coupon.issue.fields.code',
    controlName: 'couponCode',
    type: 'text',
    placeholder: 'coupon.issue.placeholders.code',
    required: true,
    section: 'coupon.issue.sections.basic_information',
    width: '1/2',
    maxLength: 100,
  },
  {
    label: 'coupon.issue.fields.name',
    controlName: 'couponName',
    type: 'text',
    placeholder: 'coupon.issue.placeholders.name',
    required: true,
    section: 'coupon.issue.sections.basic_information',
    width: '1/2',
    maxLength: 200,
  },
  {
    label: 'coupon.issue.fields.total_quantity',
    controlName: 'totalQuantity',
    type: 'number',
    placeholder: 'coupon.issue.placeholders.total_quantity',
    section: 'coupon.issue.sections.basic_information',
    width: '1/2',
    min: 1,
  },
  {
    label: 'coupon.issue.fields.linked_offer',
    controlName: 'linkedOfferId',
    type: 'dropdown',
    placeholder: 'coupon.issue.placeholders.linked_offer',
    required: true,
    section: 'coupon.issue.sections.offer_information',
    width: '1/1',
    options: [],
    showClear: true,
  },
];

/** Matches backend IssuedCouponStatus enum. */
export const ISSUED_COUPON_STATUSES = ['ACTIVE', 'VOID', 'EXHAUSTED'] as const;

export type IssuedCouponStatus = (typeof ISSUED_COUPON_STATUSES)[number];

export const ISSUED_COUPON_STATUS_OPTIONS: {
  label: string;
  value: IssuedCouponStatus;
}[] = [
  { label: 'issued_coupon.status.active', value: 'ACTIVE' },
  { label: 'issued_coupon.status.void', value: 'VOID' },
  { label: 'issued_coupon.status.exhausted', value: 'EXHAUSTED' },
];
